import { render } from "./BaseEditDialog.vue?vue&type=template&id=811f452e&scoped=true"
import script from "./BaseEditDialog.vue?vue&type=script&lang=js"
export * from "./BaseEditDialog.vue?vue&type=script&lang=js"

import "./BaseEditDialog.vue?vue&type=style&index=0&id=811f452e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811f452e"]])

export default __exports__